/**
 * 인증 플로우 중앙 팝업 (이미 등록 번호 / 네트워크 오류 / 번호 변경 확인 등)
 */
export default function CertDialog({
  open,
  icon,
  title,
  description,
  secondaryText = '닫기',
  primaryText,
  onSecondary,
  onPrimary,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/80 px-5"
      role="dialog"
      aria-modal="true"
      onClick={onSecondary}
    >
      <div
        className="w-full max-w-[320px] rounded-2xl bg-white px-2.5 py-[30px] shadow-[0_5px_16px_rgba(0,0,0,0.1)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col items-center gap-[30px]">
          <div className="flex flex-col items-center gap-5">
            {icon ? <div className="flex items-center justify-center">{icon}</div> : null}
            <div className="flex flex-col items-center gap-2.5 px-1 text-center">
              <h3 className="font-['Pretendard'] text-[22px] font-extrabold leading-[1.4] text-gray05">
                {title}
              </h3>
              {description ? (
                <p className="whitespace-pre-line font-['Pretendard'] text-[14px] leading-[1.5] text-gray04">
                  {description}
                </p>
              ) : null}
            </div>
          </div>
          <div className="flex w-full max-w-[281px] gap-2.5">
            <button
              type="button"
              onClick={onSecondary}
              className="flex h-12 flex-1 items-center justify-center rounded-[10px] border border-solid border-gray02 bg-gray01 font-['Pretendard'] text-[14px] font-bold text-gray04"
            >
              {secondaryText}
            </button>
            {primaryText ? (
              <button
                type="button"
                onClick={onPrimary}
                className="flex h-12 flex-1 items-center justify-center rounded-[10px] border border-solid border-primary-purple-01 bg-white font-['Pretendard'] text-[14px] font-bold text-primary-purple-01"
              >
                {primaryText}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
